<form (ngSubmit)="login()">
  <img
    *ngIf="!authFromHelpUkraine && !authWcd"
    src="assets/img/logo.svg"
    [alt]="'GLOBAL.app_name' | translate"
    class="logo logo--centered hidden-xs"
  />
  <img
    *ngIf="authFromHelpUkraine"
    src="assets/img/help-ukraine/PH_logo_UA.webp"
    [alt]="'GLOBAL.app_name' | translate"
    class="logo logo--centered hidden-xs"
  />
  <img
    *ngIf="authWcd"
    src="assets/img/wcd/ldiwXph.svg"
    [alt]="'GLOBAL.app_name' | translate"
    class="logo logo--centered hidden-xs"
  />
  <div class="form__group">
    <app-ph-input
      [placeholder]="'FORMS.your_email' | translate"
      type="email"
      [validation]="'email'"
      [autocomplete]="true"
      name="username"
      [correctForm]="form"
    ></app-ph-input>
  </div>
  <div class="form__group">
    <app-ph-input
      [placeholder]="'FORMS.your_password' | translate"
      [validation]="'password'"
      [autocomplete]="true"
      type="password"
      name="password"
      [correctForm]="form"
    ></app-ph-input>
  </div>
  <div class="form__action">
    <button class="btn btn--primary btn--block btn--lg" [disabled]="loading">
      {{ 'AUTH.sign_in' | translate }}
    </button>
  </div>
</form>
<div class="card__body-separator">
  <span>{{ 'AUTH.or_sign_in_with_social' | translate }}</span>
</div>
<div class="btn__group">
  <button
    class="btn btn--outline btn--block btn--md btn--fill--white"
    (click)="socialSignIn('Facebook')"
  >
    <span class="btn__icon">
      <img src="assets/img/icons/fb.svg" [alt]="'AUTH.sign_in_with_facebook' | translate" />
    </span>
    <span class="btn__text text--fb">{{ 'AUTH.sign_in_with_facebook' | translate }}</span>
  </button>
</div>
<div class="btn__group">
  <google-signin-btn></google-signin-btn>
</div>
<div class="form__link form__link--forgot-password">
  <a [routerLink]="[]" [queryParams]="authPage('reset-pass')" class="text--primary-light">{{
    'AUTH.forgot_password' | translate
  }}</a>
</div>
<div class="form__link form__link--sign-up">
  <span>{{ 'AUTH.dont_have_an_account' | translate }}</span>
  <a
    [routerLink]="[]"
    [queryParams]="authPage('register')"
    class="text--primary-light text--decorated"
  >
    {{ 'AUTH.sign_up_here' | translate }}</a
  >
</div>
